
console.log('%c👍🏼 Accordion', 'color: yellow');

const accordions = document.querySelectorAll('.accordion');
accordions.forEach(function(accordion) {
    const onlyOne = accordion.dataset.onlyOne;
    const isMinimal = accordion.classList.contains('accordion--minimal');
    const accordionItems = accordion.querySelectorAll('.accordion-item');

    accordionItems.forEach(function(accordionItem) {

        const button = accordionItem.querySelector('button')
        button.addEventListener('click', () => {
            const content = button.nextElementSibling;
            const contentInner = content.firstElementChild;
            const accordionSpan = button.querySelector('.accordion-span-2');
            const isActive = button.getAttribute('aria-expanded') === 'true';

            if(onlyOne) {
                accordion.querySelectorAll('.accordion-content').forEach(function(section) {
                    section.classList.remove('h-auto');
                    section.style.height = 0;
                    section.previousElementSibling.setAttribute('aria-expanded', 'false');
                });
            }
            if (!isActive) {
                // content.classList.add('h-auto');
                content.style.height = contentInner.clientHeight + 'px';
                button.setAttribute('aria-expanded', 'true');
                if (!isMinimal) {
                    accordionItem.classList.remove('border-gray-200');
                    accordionItem.classList.add('border-lewis-pink-normal');
                    if (accordionSpan) {
                        accordionSpan.classList.remove('top-2');
                        accordionSpan.classList.add('top-14');
                    }
                }
                if (accordionSpan) {
                    accordionSpan.classList.add('opacity-0');
                }
            } else {
                // content.classList.remove('h-auto');
                content.style.height = 0;
                button.setAttribute('aria-expanded', 'false');
                if (!isMinimal) {
                    accordionItem.classList.remove('border-lewis-pink-normal');
                    accordionItem.classList.add('border-gray-200');
                    if (accordionSpan) {
                        accordionSpan.classList.add('top-2');
                        accordionSpan.classList.remove('top-14');
                    }
                }
                if (accordionSpan) {
                    accordionSpan.classList.remove('opacity-0');
                }
            }
        });

        button.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                button.click();
            }
        });
    }); 
});